import React, { useEffect, useState } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Card14 = ({ title }) => {
  const [count, setCount] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/commande_en_retard`)
      .then((res) => { if (!res.ok) throw new Error('Erreur API'); return res.json(); })
      .then((data) => {
        if (!Array.isArray(data)) { setCount(0); return; }
       const uniqueLignes = new Set(data.map((row) => row['Numero de commande']).filter(Boolean));
        setCount(uniqueLignes.size);
      })
      .catch((err) => { console.error('Erreur chargement commande_en_retard :', err); setError(true); setCount(0); });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '120px', width: '220px', backgroundColor: '#ffffff', border: '1px solid #f0ece2', borderRadius: '14px', padding: '16px 20px', boxSizing: 'border-box', position: 'relative', overflow: 'hidden', cursor: 'pointer' }}>

      {/* Barre accent — ROUGE */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #7f1d1d, #f87171)', borderRadius: '14px 14px 0 0' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '28px', height: '28px', backgroundColor: '#fee2e2', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <span style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '15px', fontWeight: '500', color: '#8b7b64', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Cmdes en retard</span>
      </div>

      <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '32px', fontWeight: '600', color: error ? '#ef4444' : '#0f172a', lineHeight: 1, textAlign: 'center' }}>
        {count === null ? <span style={{ fontSize: '20px', color: '#cbd5e1' }}>—</span> : count}
      </div>
    </div>
  );
};

export default Card14;